import React from 'react';
import { LocantoPage } from './pages/LocantoPage';
export function App() {
  return <LocantoPage data-id="element-0" />;
}